<template>
    <div class="participant-competences">
        <div v-if="!hasData" class="empty">
            Компетенции и навыки не добавлены
        </div>
        <div v-else class="content">
            <CompetenceLink
                v-for="competence in softCompetences"
                :key="competence.id"
                class="item"
                :cid="competence.id"
                :name="competence.name"
                competence-type="soft"
                mode="soft"
            />
            <CompetenceLink
                v-for="competence in hardCompetences"
                :key="competence.id"
                class="item"
                :cid="competence.id"
                :name="competence.name"
                competence-type="hard"
                mode="hard"
            />
        </div>
    </div>
</template>

<script>
import CompetenceLink from "@/components/new-competences/CompetenceLink";

export default {
    name: "ParticipantCompetences",

    components: {
        CompetenceLink,
    },

    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        hasData() {
            return this.items && this.items.length;
        },

        softCompetences() {
            return this.items.filter(el => el.type === 'soft');
        },

        hardCompetences() {
            return this.items.filter(el => el.type === 'hard');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.participant-competences {
    .empty {
        font-family: 'Proxima Nova', sans-serif;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #98A0A9;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }

    .item {
        margin: 0 0 rem(24);

        @include on-mobile {
            margin: 0 0 mrem(24);
        }

        &:last-of-type {
            margin: 0;
        }
    }
}
</style>